import React, { PropsWithChildren } from 'react'
import Label from 'components/Luxkit/Label/Label'
import styled from 'styled-components'

const LabelElement = styled(Label)`
  background-color: ${props => props.theme.palette.product.loyalty};
  color: ${props => props.theme.palette.neutral.eight};
  border: 0 !important;
`

interface Props extends PropsWithChildren<{}> {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

function LuxuryPlusLabel({ children, ...rest }: Props) {
  return (
    <LabelElement kind="primary" variant="grey" {...rest}>
      {children}
    </LabelElement>
  )
}

export default LuxuryPlusLabel
